
const blankImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=';

const imageLoader = (imageUrl: string) : Promise<HTMLImageElement> => {
  if (!imageUrl) {
    imageUrl = blankImage;
  }
  else {
    imageUrl = imageUrl.replace('https://gatorstep.com', '');
    imageUrl = imageUrl.replace('https://yamaha.gatorstep.com', '');
    imageUrl = imageUrl.replace('https://seahunt.gatorstep.com', '');
  }
  
  return new Promise<HTMLImageElement>((resolve, reject) => {
    let img = new Image();
    img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.src = imageUrl;
  });
};

const loadAllImages = (imageSources: string[]) => {
  return Promise.all(imageSources.map(imageSource => imageLoader(imageSource)));
}

export {
  imageLoader,
  loadAllImages
}